import { useState } from 'react'

export const usePreventScrollClick = (threshold = 10) => {
  const [startTouch, setStartTouch] = useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = useState(false)

  const handleTouchStart = (event: React.TouchEvent) => {
    setStartTouch({
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    })
    setIsDragging(false)
  }

  const handleTouchMove = (event: React.TouchEvent) => {
    const moveX = event.touches[0].clientX
    const moveY = event.touches[0].clientY
    if (Math.abs(moveX - startTouch.x) > threshold || Math.abs(moveY - startTouch.y) > threshold) {
      setIsDragging(true)
    }
  }

  const handleTouchEnd = (event: React.TouchEvent) => {
    if (isDragging) {
      event.preventDefault()
      setIsDragging(false)
    }
  }

  return {
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    isDragging,
  }
}
